module.exports = __webpack_public_path__ + "static/13-5c46ce0cc1cf7b627e2d7b2effb5a338.png";